<script setup lang="ts">

import {ref, computed} from 'vue';
import {SvgIcon} from '../../../svg.ts';

import FileTreeItem from '../FileTreeItem.vue';
import type {FileTreeDirectory} from '../../types/file_tree.ts';
const {icon, item, forceExpand = false} = defineProps<{
  icon: string,
  item: FileTreeDirectory,
  forceExpand?: boolean,
}>();

const collapsed = ref(false);
const isExpanded = computed(() => forceExpand || !collapsed.value);
</script>

<template>
  <div
    class="tw:flex tw:gap-1 tw:p-1 tw:items-center tw:hover:cursor-pointer tw:hover:bg-hover"
    :title="item.headPath"
    @click.stop="collapsed = !collapsed"
  >
    <SvgIcon :name="isExpanded ? 'octicon-chevron-down' : 'octicon-chevron-right'" />
    <SvgIcon
      class="text primary"
      :name="icon"
    />
    <span class="tw:text-ellipsis tw:overflow-hidden tw:whitespace-nowrap">{{ item.name }}</span>
  </div>
  <!-- Children -->
  <div
    v-show="isExpanded"
    class="tw:ml-3 tw:border-l tw:pl-3 tw:border-secondary"
  >
    <FileTreeItem
      v-for="child in item.children"
      :key="child.headPath"
      :item="child"
      :force-expand="forceExpand"
    />
  </div>
</template>
